import React from 'react';
import { Button, Col, Input, Form } from 'antd';
import ImageComponent from '@sharedComponent/image-component';
import { images } from '@assets/img';
import { Link } from 'react-router-dom';
const layout = {
	labelCol: { span: 24 },
	wrapperCol: { span: 24 },
};

export const ForgotPasswordPresentational = ({ state, onFinish, goToLogin }) => {
	const [formRef] = Form.useForm();
	formRef.setFieldsValue({
		email: state.email,
	});

	return (
		<>
			<ImageComponent className="verify_back" src={images.fullscreen} />
			<Col className="center_area">
				<Col className="body">
					<ImageComponent className="logo" src={images.logo_sm} />
					<Col className="head">Reset Password </Col>
					{!state.iscardActive ? (
						<Col className="content">
							<Form
								style={{ marginTop: '30px' }}
								hideRequiredMark={true}
								{...layout}
								layout="vertical"
								name="control-ref"
								form={formRef}
								onFinish={onFinish}>
								<Form.Item
									validateTrigger={['onChange', 'onBlur']}
									className="noreq"
									name="email"
									label="E-mail Address"
									rules={[
										{
											required: true,
											message: 'Invalid Email!',
										},
									]}>
									<Input type="email" />
								</Form.Item>
								<Col className="btn_area">
									<Col className="">
										<Button className="k_btn" htmlType="submit">
											Reset My Password
										</Button>
									</Col>
								</Col>
							</Form>
						</Col>
					) : null}
					{state.iscardActive ? (
						<>
							<Col className="content">
								If the email you specified exists in our system, we've sent a password reset link to it.{'  '}
							</Col>
							<Col>
								<Link className="goSignIn" to="/login">
									{' '}
									Click to Sign In
								</Link>
							</Col>
						</>
					) : null}
				</Col>
			</Col>
		</>
	);
};
